import { camelCase } from 'lodash';
import { Field } from 'api/tasks';

export const byFieldName = (f: Field, fieldName: string) =>
  camelCase(f.fieldName) === camelCase(fieldName);
